import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { default as BaseButton } from '../../../BaseComponents/Button';
import { useRenderers } from '../../../renderProps';
import { useTheme } from '../../../theme';
import { TABLET_MIN_WIDTH } from '../../../utils';
const FooterButtons = ({ showButtons, outDate, returnDate, buttonRendererProps }) => {
    const { t } = useTranslation('SearchFormDatepicker');
    const { SearchFormDatepickerStyles: datepickerTheme } = useTheme('SearchFormDatepicker');
    const isMobile = useMediaQuery({ maxWidth: TABLET_MIN_WIDTH - 1 });
    const { renderAdaptiveSearchFormDatepickerControls } = useRenderers();
    if (renderAdaptiveSearchFormDatepickerControls) {
        return React.createElement(React.Fragment, null, renderAdaptiveSearchFormDatepickerControls(buttonRendererProps));
    }
    if (!showButtons || (isMobile && !outDate)) {
        return null;
    }
    return (React.createElement("div", { className: datepickerTheme.footer__buttons },
        React.createElement(BaseButton, { variant: "smallSecondary", className: datepickerTheme.footer__clear, disabled: !buttonRendererProps.notActive, onClick: buttonRendererProps.onClear }, t('Clear')),
        React.createElement(BaseButton, { variant: "smallThird", className: datepickerTheme.footer__done, disabled: !buttonRendererProps.isDoneable, onClick: buttonRendererProps.isDoneable ? buttonRendererProps.onDone : null }, outDate && !returnDate ? t('One way') : t('Done'))));
};
export default FooterButtons;
